export default __webpack_public_path__ + "images/BroadBand_Banner.png";